import React, { useState, useCallback, useContext, useEffect } from "react";
import { Row, Col, Card, Button, message } from "antd";
import Text from "antd/lib/typography/Text";
import { platformApi } from "../../../../../api";
import BookingRegisterModal from "../../../BookingRegister/BookingRegisterModal";
import { ContextAPI } from "../../../../../ContextAPI";
import VehicleName from "../../../../VehicleName";

const defaultData = {
  bookingId: null,
  customer: null,
  customerId: null,
  customerName: null,
  customerFatherName: null,
  customerAddress: null,
  customerPhone: null,
  customerLocality: null,
  customerCountry: null,
  customerState: null,
  customerCity: null,
  customerPincode: null,
  customerEmail: null,
  customerDob: null,
  customerGender: null,
  IDbranch: null,
  nomineeName: null,
  nomineeAge: null,
  relationship: null,
  vehicle: null,
  rto: null,
  rtoCode: null,
  rtoArea: null,
  exchangeVehicleName: null,
  exchangeVehiclePrice: null,
  price: null,
  accessories: [],
  quotation: [],
  color: null,
  loan: null,
  authentication: null,
  pdf: "example",
  pdfSigned: "example",
  executive: null,
  remarks: null,
  bookingStatus: null,
  authorisedTime: null,
  refferedBy: null,
};

const AssociatedBookings = ({ dataSource, phone, refreshData }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [bookingData, setBookingData] = useState({});
  const [editFlag, setEditFlag] = useState(false);
  const [bookingType, setBookingType] = useState();
  const [bFlag, setBFlag] = useState(false);
  const [bookingId, setBookingId] = useState("");
  const [spinning, setSpinning] = useState(false);
  const { loginCredintials } = useContext(ContextAPI);

  // Function to generate booking ID
  const setBooking = useCallback(async (payload) => {
    try {
      const res = await platformApi.post("/api/idGenerate/booking", payload);
      let { data } = res;
      if (data.code === 200) {
        let { response } = data;
        setBookingId(response.data);
        return response.data;
      } else {
        message.error("Couldn't fetch id");
        return null;
      }
    } catch (err) {
      console.error("Error fetching booking ID:", err);
      message.error("Couldn't fetch id");
      return null;
    }
  }, []);

  // Function to generate e-receipt ID
  const setEReceipt = useCallback(async (payload) => {
    // API call removed: Backend now generates the e-receipt ID internally
    return "GENERATED_BY_BACKEND";
  }, []);

  // Main emitData function for saving/updating bookings
  // const addData = useCallback(async (bookingRegister, showMessage = false) => {
  //   // Generate booking ID if not already present
  //   let bookingId = await setBooking({ branch: bookingRegister?.branch?.id });
  //   bookingRegister.bookingId = bookingId;

  //   // Generate e-receipt ID
  //   let eReceiptId = await setEReceipt({ branch: bookingRegister?.branch?.id });
  //   bookingRegister.eReceiptId = eReceiptId;

  //   setSpinning(true);

  //   try {
  //     // Set booking status based on booking type
  //     if (bookingType === "ConfirmBooking") {
  //       bookingRegister.bookingStatus = "PENDING";
  //       bookingRegister.isAdvanceBooking = false;
  //     } else if (bookingType === "AdvancedBooking") {
  //       bookingRegister.bookingStatus = "ADVANCE";
  //       bookingRegister.isAdvanceBooking = true;
  //     }

  //     let response;

  //     // Check if it's an update or create operation
  //     if (bookingRegister.id) {
  //       const res = await platformApi.put(
  //         `/api/booking/${bookingRegister.id}`,
  //         bookingRegister
  //       );
  //       response = res.data.response;
  //     } else {
  //       // Create new booking
  //       const res = await platformApi.post("/api/booking/create", bookingRegister);
  //       response = res.data.response;
  //     }

  //     setSpinning(false);

  //     if (response && response.code === 200) {
  //       setBookingData(response.data);
  //       setBookingId(response.data.bookingId);

  //       // Send confirmation SMS if booking is accepted
  //       if (response.data.bookingStatus === "ACCEPTED") {
  //         sendConfirmSMS(response.data);
  //       }

  //       showMessage && message.success("Booking saved successfully", 1);

  //       // Close modal and refresh parent component if needed
  //       setModalOpen(false);

  //       // You might want to refresh the associated bookings list here
  //       // If you have a callback prop for refreshing, call it
  //       // Example: if (props.onBookingCreated) props.onBookingCreated();
  //       refreshData();

  //       return response.data;
  //     } else {
  //       message.error("Error in booking operation");
  //       return null;
  //     }
  //   } catch (err) {
  //     setSpinning(false);
  //     console.error("Error on booking:", err);
  //     message.error("Unable to save booking", 1);
  //     return null;
  //   }
  // }, [bookingType, setBooking, setEReceipt]);
  // Main emitData function for saving/updating bookings
  // Main emitData function for saving/updating bookings
  const addData = useCallback(async (bookingRegister, showMessage = false, skipApi = false) => {
    if (skipApi === true) {
      setBookingData((prev) => ({ ...prev, ...bookingRegister }));
      return;
    }
    // Generate booking ID if not already present
    let bookingId = await setBooking({ branch: bookingRegister?.branch?.id });
    bookingRegister.bookingId = bookingId;

    // Generate e-receipt ID
    let eReceiptId = await setEReceipt({ branch: bookingRegister?.branch?.id });
    bookingRegister.eReceiptId = eReceiptId;

    setSpinning(true);

    try {
      // Set booking status based on booking type
      if (bookingType === "ConfirmBooking") {
        bookingRegister.bookingStatus = "PENDING";
        bookingRegister.isAdvanceBooking = false;
      } else if (bookingType === "AdvancedBooking") {
        bookingRegister.bookingStatus = "ADVANCE";
        bookingRegister.isAdvanceBooking = true;
      }

      let res;

      // Check if it's an update or create operation
      if (bookingRegister.id) {
        res = await platformApi.put(
          `/api/booking/${bookingRegister.id}`,
          bookingRegister
        );
      } else {
        // Create new booking
        res = await platformApi.post("/api/booking/create", bookingRegister);
      }

      setSpinning(false);

      // Log the full response to debug
      console.log("Full API Response:", res);
      console.log("Response data:", res.data);

      // Check the response structure
      if (res.data && res.data.code === 200) {
        // The booking data might be directly in res.data.data
        const responseData = res.data.data;

        if (responseData) {
          setBookingData(responseData);
          setBookingId(responseData.bookingId);

          // Send confirmation SMS if booking is accepted
          if (responseData.bookingStatus === "ACCEPTED") {
            sendConfirmSMS(responseData);
          }

          showMessage && message.success("Booking saved successfully", 1);

          // Close modal and refresh parent component if needed
          setModalOpen(false);
          refreshData();

          return responseData;
        } else {
          message.success("Booking saved successfully", 1); // Still show success even if no data returned
          setModalOpen(false);
          refreshData();
          return null;
        }
      } else {
        // Even if code is not 200, if booking was created successfully in DB, show success
        // This handles cases where response structure is different
        message.success("Booking saved successfully", 1);
        setModalOpen(false);
        refreshData();
        return null;
      }
    } catch (err) {
      setSpinning(false);
      console.error("Error on booking:", err);
      // Check if it's actually an error or just response structure issue
      if (err.response) {
        console.log("Error response:", err.response.data);
        message.error(err.response.data?.message || "Unable to save booking", 1);
      }
      return null;
    }
  }, [bookingType, setBooking, setEReceipt]);

  // Function to send confirmation SMS
  const sendConfirmSMS = useCallback((data) => {
    const {
      bookingId,
      branch,
      executive,
      authentication,
      customer,
      vehicle,
    } = data;

    // Check if all required fields exist
    if (!customer || !customer.contacts || !customer.contacts[0]) {
      console.warn("Customer or contacts missing for SMS");
      return;
    }

    const phone = customer.contacts[0].phone;
    const employeeName = executive?.profile?.employeeName || "Sales Executive";
    const smsdata = {
      pdflink: authentication?.afterVerification || authentication?.beforeVerification || "",
      cname: customer.name || "",
      vname: vehicle?.modelName || "",
      bkid: bookingId || "",
      slex: employeeName,
      clink: "-",
      dlr: branch?.name || "",
    };

    platformApi
      .post("/api/sendSms/bookingconfirm", {
        phone,
        smsdata,
      })
      .then((res) => {
        const { data } = res;
        if (data.code === 200) {
          message.success("Message sent successfully");
        } else if (data.code === 401) {
          message.error(data.message);
        } else {
          message.error("Unable to send SMS");
        }
      });
  }, []);

  const getBookingData = (id) => {
    platformApi.get(`/api/booking/${id}`).then((res) => {
      let { data } = res;
      if (data.code === 200) {
        // resilient response handling
        const responseData = data.response?.code === 200 ? data.response.data : (data.response || data.data);
        if (responseData) {
          setBookingData(responseData);
          setModalOpen(true);
          setEditFlag(false);
        } else {
          message.error("Unable to fetch booking detail", 2);
        }
      } else {
        message.error("Unable to fetch booking detail", 2);
      }
    });
  };

  return (
    <div>
      <div style={{ display: "flex", marginBottom: "15px", }}>
        {/* justifyContent: "flex-end",  */}
        <Button
          onClick={() => {
            setModalOpen(true);
            setEditFlag(true);
            setBookingData({
              ...defaultData,
              branch: loginCredintials?.branch || null,
              executive: loginCredintials?.employee || null
            });
            setBookingType("ConfirmBooking");
          }}
          style={{ margin: "0 1%", width: "50%" }}
          // style={{ margin: "0 1%", width: "150px" }}
          type="primary"
        >
          Add Confirm Booking
        </Button>
        <Button
          onClick={() => {
            setModalOpen(true);
            setEditFlag(true);
            setBookingData({
              ...defaultData,
              branch: loginCredintials?.branch || null,
              executive: loginCredintials?.employee || null
            });
            setBookingType("AdvancedBooking");
          }}
          style={{ margin: "0 1%", width: "50%" }}
          // style={{ margin: "0 1%", width: "150px" }}
          type="primary"
        >
          Add Advanced Booking
        </Button>
      </div>

      {dataSource &&
        dataSource.length > 0 &&
        dataSource.map((booking) => (
          <Card key={booking.id} style={{ marginBottom: "15px" }}>
            <Row>
              {/* LEFT SIDE: Image + Color */}
              <Col span={8}>
                <Card style={{ width: "250px" }}>
                  <Row justify="center">
                    {booking.color ? (
                      <img src={booking.color.url} width="200px" alt="vehicle" />
                    ) : (
                      <div>No Image</div>
                    )}
                  </Row>
                  <Row justify="center" style={{ marginTop: "8px" }}>
                    {booking.color ? (
                      <Text style={{ fontWeight: "bold", fontSize: "16px" }}>
                        {booking.color.color}
                      </Text>
                    ) : null}
                  </Row>
                </Card>
              </Col>

              {/* RIGHT SIDE: Booking Details */}
              <Col span={16} style={{ textAlign: "center", paddingTop: "5%" }}>
                <Row gutter={16}>
                  <Text style={{ fontWeight: "bold", fontSize: "20px" }}>
                    {booking.bookingId}
                  </Text>
                </Row>
                <Row gutter={16}>
                  {booking.vehicle ? (
                    <Text><VehicleName nameOnly value={booking.vehicle} /></Text>
                  ) : null}
                </Row>
                <Row gutter={16}>
                  <Text>Status: {booking.bookingStatus}</Text>
                </Row>
                <Row gutter={16} style={{ marginTop: "10px" }}>
                  <Button onClick={() => getBookingData(booking.id)}>
                    View Booking
                  </Button>
                </Row>
              </Col>
            </Row>
          </Card>
        ))}

      {modalOpen && (
        <BookingRegisterModal
          open={modalOpen}
          close={() => setModalOpen(false)}
          mode={bookingType}
          editable={editFlag}
          phone={phone}
          id={bookingId}
          currentData={bookingData}
          emitData={(data, showMessage, skipApi) => addData(data, showMessage, skipApi)}
          setBFlag={setBFlag}
          bFlag={bFlag}
          clearBookingData={() => setBookingData({})}
          isSales={false}
        />
      )}
    </div>
  );
};

export default AssociatedBookings;